var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeModule } from "./NativeModule";
import { NativeInterface } from "./NativeInterface";
var BarcodeCameraReaderNative = /** @class */ (function (_super) {
    __extends(BarcodeCameraReaderNative, _super);
    function BarcodeCameraReaderNative() {
        var _this = _super.call(this) || this;
        _this.onDetectedAdvanced = null;
        NativeInterface.instance.addModule(_this);
        return _this;
    }
    BarcodeCameraReaderNative.prototype.getPrefix = function () {
        return 'barcodeCamera_';
    };
    /**
     * Enable the physical reader
     * @returns {Promise<void>}
     */
    BarcodeCameraReaderNative.prototype.enable = function (args) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'enable',
            params: args
        });
    };
    BarcodeCameraReaderNative.prototype.onEvent = function (event) {
        if (event.name == this.getPrefix() + 'detected') {
            console.log('BarcodeReader:', event);
            if (this.onDetectedAdvanced)
                this.onDetectedAdvanced(event.params);
        }
    };
    BarcodeCameraReaderNative.prototype.read = function (args, timeout) {
        var _this = this;
        if (args === void 0) { args = {}; }
        if (timeout === void 0) { timeout = 60 * 1000; }
        this.onDetectedAdvanced = null;
        return this.enable(args).then(function () {
            return new Promise(function (resolve, reject) {
                var rejectTimeout = setTimeout(function () {
                    reject({ error: 'reader_timeout' });
                }, timeout);
                _this.onDetectedAdvanced = function (content) {
                    clearTimeout(rejectTimeout);
                    resolve(content);
                };
            });
        });
    };
    /**
     * Is the reader available/compatible on the device
     * @returns {Promise<{back : boolean, front:boolean}>}
     */
    BarcodeCameraReaderNative.prototype.available = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'available',
            params: {}
        });
    };
    return BarcodeCameraReaderNative;
}(NativeModule));
export { BarcodeCameraReaderNative };
//# sourceMappingURL=BarcodeCameraNative.js.map